import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import stylesCard from "../../../components/Card/AdminCard.module.css";
import RoleCreation from "../../../components/Admin/Roles/RoleCreation";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExternalLink} from "@fortawesome/free-solid-svg-icons";
import {getUtilisateurRoleIcon, getUtilisateurRoleLabel} from "../../../services/UserService";
import styles from "../Admin.module.css";

function AdminRolesPage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const { updateDynamicBreadcrumb } = useBreadcrumb();

    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    useEffect(() => {
        (async () => {
            try {
                const response = await AxiosConfig.get(`/admin/roles`);

                const parseData = response.data.myRoles;
                setMyApiData(parseData);
            } catch (error) {
                console.error('error', error);
            }
        })();
    }, [user]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({  }));
    }, []);

    return (
        <div className="content">
            <TitleMain text="Rôles"/>

            <div className={styles.viewBloc}>
                <ul style={{ display: "flex", flexDirection: "column", gap: "4px", width: "fit-content" }}>
                    {myApiData.map((role, index) => {
                        return (
                            <li key={index}>
                                <Link to={role.role} style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    gap: "5px"
                                }}>
                                    { getUtilisateurRoleIcon(role.role) }
                                    { getUtilisateurRoleLabel(role.role) }
                                    <FontAwesomeIcon icon={faExternalLink} style={{marginLeft: "2px"}}/>
                                </Link>
                            </li>
                        )
                    })}
                </ul>
            </div>

        </div>
    )
}

export default AdminRolesPage;
